import { memo } from 'react';
import { Handle, Position, type NodeProps } from 'reactflow';
import { FileSearch } from 'lucide-react';

interface FetchDocumentNodeData {
    label?: string;
    documentType?: string; // e.g. "Referral", "LabReport"
}

export const FetchDocumentNode = memo(({ data, isConnectable, selected }: NodeProps<FetchDocumentNodeData>) => {
    return (
        <div className={`
            px-4 py-3 rounded-lg shadow-lg border-2 bg-white min-w-[180px]
            ${selected ? 'border-indigo-500 shadow-indigo-100 ring-2 ring-indigo-200' : 'border-slate-200 hover:border-indigo-300'}
            transition-all duration-200
        `}>
            {/* Input Handle */}
            <Handle
                type="target"
                position={Position.Left}
                isConnectable={isConnectable}
                className="w-3 h-3 bg-slate-400 !border-2 !border-white"
            />

            <div className="flex items-center gap-3">
                <div className={`
                    p-2 rounded-lg shrink-0
                    ${selected ? 'bg-indigo-100 text-indigo-600' : 'bg-indigo-50 text-indigo-500'}
                `}>
                    <FileSearch size={18} />
                </div>

                <div className="flex flex-col">
                    <span className="text-xs font-bold text-slate-700 uppercase tracking-wider">
                        Fetch Document
                    </span>
                    <span className="text-xs text-slate-500 truncate font-medium">
                        {data.documentType || "Select Type"}
                    </span>
                </div>
            </div>

            {/* Output Handle */}
            <Handle
                type="source"
                position={Position.Right}
                isConnectable={isConnectable}
                className="w-3 h-3 bg-indigo-500 !border-2 !border-white"
            />
        </div>
    );
});
